const Style = {
    container: 'bg-white/80 shadow rounded-2xl p-2 mb-2 flex flex-col cursor-pointer hover:bg-slate-100 transition-all duration-200',
    bottom: 'flex justify-between items-center mt-2',
    date: 'text-xs text-slate-500',
    top: 'flex justify-between items-center',
    text: 'text-sm text-slate-700 pr-8',
}

export default Style;